module.exports = __webpack_public_path__ + "img/0090.9ce42468.jpg";